import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { task } from 'ember-concurrency';

class MmcImportSettings {
  id = 0;
  recordType = 'tool-mmc-importer';
  @tracked cover = false;
  @tracked force = false;
  @tracked upc = '';

  toJSON() {
    let { cover, force, upc } = this;
    return { cover, force, upc };
  }

  reset() {
    this.cover = false;
    this.force = false;
    this.upc = '';
  }
}

export default class AdminToolMmcImporterController extends Controller {
  // Service
  @service fetch;
  @service flashMessages;
  @service headData;
  @service intl;

  // Defaults
  mmcImportSettings = new MmcImportSettings();

  // Actions
  setHeadData = () => {
    this.headData.title = this.intl.t('tool_mmc_importer.headline');
    this.headData.favicon = 'tool-mmc-importer';
  };

  // Tasks
  mmcImport = task({ restartable: true }, async () => {
    try {
      const response = await this.fetch.post('/tools/manualMMC', {
        data: this.mmcImportSettings.toJSON(),
      });

      this.mmcImportSettings.reset();

      const message = this.intl.t('tool_mmc_importer.imported', {
        upc: response.upc,
        title: response.title,
      });

      this.flashMessages.success(message, {
        rawString: true,
      });
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  });
}
